import React from "react";
import _getConditions from "./condition-builder.js";
import { Translate } from "orion-components/i18n";

const lprWatchlistMatchBuilder = (rule, collections, shapes) => {
	return (
		<div id="rule-statement" className="cb-font-b9">
			<Translate value="global.ruleBuilder.lprWatchlistMatch.alarmMe" />
			{_getWatchlists(rule)}
			{_getConditions(rule, collections, shapes)}
		</div>
	);
};

const _getWatchlists = rule => {
	if (!rule.targets || rule.targets.length === 0) {
		return <Translate value="global.ruleBuilder.lprWatchlistMatch.anyWatchlist" />;
	} else {
		return rule.targets.map((watchlist, index) => {
			return (
				<span key={watchlist.id} className="rule-statement-container">
					{index > 0 && (
						<span>
							<Translate value="global.ruleBuilder.lprWatchlistMatch.or" />
						</span>
					)}
					<span>{watchlist.name}</span>
				</span>
			);
		});
	}
};

export default lprWatchlistMatchBuilder;
